export const isCompositionPremium = (comp) => comp?.premiumLineItems?.length > 0 || false;